import {timesheetCatalogs} from "../../utils/timesheetCatalogs";
import { contractDate } from "../../utils/planningDates";
import { getISOWeek, getISOWeekYear, startOfISOWeek, addDays } from "date-fns";
import "../../styles/timesheetDetail.css";
import { primeSummary } from "../../utils/primeAmount";
import { applyPrimeRates, hourOptionsFromContract, mergePrimeCatalog } from "../../utils/primeCatalog";
import HourInput from "../../components/HourInput";
import { formatHourInput } from "../../utils/hourInput";
import { absenceReasons, hasDayHours, missingAbsenceDays } from "../../utils/timesheetAbsences";
import axios from "../../axios/AxiosInstance";
import { saveAs } from "file-saver";
import { createTimesheetPdf } from "../../utils/timesheetPdf";
import { frenchDate } from "../../utils/frenchDate";
import PageHeading from "../../components/PageHeading";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { Trash2, Pencil, Clock, User, Download, Save, Send, ArrowLeft, Sun, Moon, FileText, DollarSign, Gift, MessageSquare, AlertCircle, Edit3, Plus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import releveHeuresService from "../../services/releveHeuresService";
import { toast } from "react-toastify";




const emptyWeek = () => ({ lundi: "", mardi: "", mercredi: "", jeudi: "", vendredi: "", samedi: "", dimanche: "" });
const emptyTimeSheet = {
  id: "",
  weekNumber: "—",
  year: "—",
  startDate: "",
  endDate: "",
  employeeName: "",
  employeePosition: "",
  employeeCompany: "",
  employeeId: "",
  hours: emptyWeek(),
  nightHours: emptyWeek(),
  absences: emptyWeek(),
  status: "pending",
  clientComment: "",
  employeeComment: "",
  projectNumber: "",
  endOfMission: false
};
const parseDate = value => {
  const french = String(value || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return contractDate(french ? `${french[3]}-${french[2]}-${french[1]}` : value);
};

const RelevesHeures = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [timeSheet, setTimeSheet] = useState(emptyTimeSheet);
  const [hourFormat, setHourFormat] = useState("minutes");
  const [invalidHourFields, setInvalidHourFields] = useState({});
  const hourValidity = (id, valid) => setInvalidHourFields(current => ({ ...current, [id]: !valid }));
  const [nightHoursOption] = useState("additional"); // Les heures de nuit s’ajoutent aux heures de jour.
  const [weekHoursOption] = useState("35h");
  const [clientComment, setClientComment] = useState("");
  const [employeeComment, setEmployeeComment] = useState("");
  const [isLoading, setIsLoading] = useState(() => Boolean(new URLSearchParams(location.search).get("id")));
  const [loadError, setLoadError] = useState(() => new URLSearchParams(location.search).get("id") ? "" : "Aucun relevé sélectionné. Retournez à la liste et choisissez un RH.");
  const [entryMode, setEntryMode] = useState("manual");
  const [excelFile, setExcelFile] = useState(null);
  const [attachmentBusy, setAttachmentBusy] = useState(false);
  const attachExcel = async event => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (!/\.(xlsx|xls|pdf)$/i.test(file.name) || file.size > 10 * 1024 * 1024) { toast.error("Choisissez un fichier Excel (.xlsx, .xls) ou PDF de 10 Mo maximum."); return; }
    if (!releveHeureId) { toast.error("Ouvrez un relevé depuis la liste pour y déposer un fichier."); return; }
    setAttachmentBusy(true);
    try { await releveHeuresService.setAttachment(releveHeureId, file); setExcelFile(file); }
    catch { toast.error("Impossible d’enregistrer ce fichier."); }
    finally { setAttachmentBusy(false); }
  };
  const removeExcel = async () => {
    setAttachmentBusy(true);
    try { if (releveHeureId) await releveHeuresService.removeAttachment(releveHeureId); setExcelFile(null); }
    catch { toast.error("Impossible de retirer le fichier."); }
    finally { setAttachmentBusy(false); }
  };
  const [primeCatalog, setPrimeCatalog] = useState([]);
  const [heureCatalog, setHeureCatalog] = useState([]);
  const catalogs=timesheetCatalogs(primeCatalog,heureCatalog);
  const indemniteCatalog=catalogs.indemnities;
  const [primes, setPrimes] = useState([]);
  const [indemnites, setIndemnites] = useState([]);
  const [selectedIndemnite, setSelectedIndemnite] = useState(null);
  const [quantiteIndemnite, setQuantiteIndemnite] = useState("");
  const [montantIndemnite, setMontantIndemnite] = useState("");
  const [editingIndemniteId, setEditingIndemniteId] = useState(null);
  const [heures, setHeures] = useState([]);
  const visibleHeures = heures.filter(row => String(row.type || "").trim() || Number(row.quantite) > 0);
  const [selectedPrime, setSelectedPrime] = useState(null);
  const [quantitePrime, setQuantitePrime] = useState('');
  const [montantPrime, setMontantPrime] = useState('');
        const [editingPrimeId, setEditingPrimeId] = useState(null);
    const [selectedHeure, setSelectedHeure] = useState(null);
  const [quantiteHeure, setQuantiteHeure] = useState('');
  const [editingHeureId, setEditingHeureId] = useState(null);
  const isPdfExporting = false;
  const [isLocked, setIsLocked] = useState(false); // Verrouillage uniquement après transmission.
  const [modificationRequested, setModificationRequested] = useState(false); // demande en attente
  const [modificationApproved] = useState(false); // validé par l'agence (via API plus tard)
  const [isSaving, setIsSaving] = useState(false);
  const [releveHeureId, setReleveHeureId] = useState(null);




  const handleDeleteIndemnite = id => setIndemnites(current => current.filter(row => row.id !== id));
  const startEditIndemnite = row => {
    setEditingIndemniteId(row.id); setSelectedIndemnite({ label: row.type });
    setMontantIndemnite(row.montant ?? ""); setQuantiteIndemnite(row.quantite);
  };
  const handleUpdateIndemnite = () => {
    if (!selectedIndemnite || !Number.isFinite(Number(montantIndemnite)) || Number(montantIndemnite) < 0 || Number(quantiteIndemnite) <= 0) return;
    setIndemnites(current => current.map(row => row.id === editingIndemniteId ? { ...row, type: selectedIndemnite.label, idPrime: selectedIndemnite.idPrime || row.idPrime, tauxFacture: selectedIndemnite.tauxFacture ?? row.tauxFacture, montant: Number(montantIndemnite), quantite: Number(quantiteIndemnite), nonAssujettie: true } : row));
    setEditingIndemniteId(null); setSelectedIndemnite(null); setMontantIndemnite(""); setQuantiteIndemnite("");
  };

  const handleSave = async () => {
    if ((isLocked && !modificationApproved) || isSaving) return;
    if (!validerAvantEnregistrement()) {
      return;
    }

    setIsSaving(true);
    try {
      if (entryMode === "excel") {
        if (!releveHeureId) throw new Error("Relevé non enregistré");
        await releveHeuresService.setAttachment(releveHeureId, excelFile);
        toast.success("Fichier enregistré.");
        return;
      }
      const releveData = {
        ...timeSheet,
        heures,
        primes: [...primes, ...indemnites], // Combiner primes et indemnités
        clientComment,
        employeeComment
      };

      if (releveHeureId) {
        // Mise à jour d'un relevé existant
        await releveHeuresService.updateReleveHeure(releveHeureId, releveData);
        toast.success("Relevé d'heures mis à jour avec succès !");
      } else {
        // Création d'un nouveau relevé (pour l'instant, on garde la logique existante)
        throw new Error("Aucun relevé enregistré : ouvrez un relevé depuis la liste avant de sauvegarder.");
      }

    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      toast.error('Erreur lors de la sauvegarde du relevé d\'heures');
    } finally {
      setIsSaving(false);
    }
  };

  const handleModificationRequest = async () => {
    if (!releveHeureId || modificationRequested) return;
    try {
      await releveHeuresService.addHistory([releveHeureId], "Demande de modification du relevé par le freelance", Number(timeSheet.weekNumber), Number(timeSheet.year));
      setModificationRequested(true);
      toast.info("Demande enregistrée dans l’historique du relevé pour l’agence.");
    } catch {toast.error("La demande n’a pas pu être enregistrée. Réessayez.");}
  };

  // Exemple à appeler quand tu reçois une réponse positive
  

  const handleAddHeure = () => {
  if (selectedHeure && quantiteHeure) {
    setHeures(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedHeure.label,
        quantite: parseFloat(quantiteHeure),
        taux: selectedHeure.taux,
      }
    ]);
    setSelectedPrime(null);
    setQuantiteHeure('');
  }
};
  
  const handleAddPrime = () => {
  if (selectedPrime && montantPrime && quantitePrime) {
    setPrimes(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedPrime.label,
        idPrime: selectedPrime.idPrime,
        tauxFacture: selectedPrime.tauxFacture,
        montant: parseFloat(montantPrime),
        quantite: parseFloat(quantitePrime),
      }
    ]);
    setSelectedPrime(null);
    setMontantPrime('');
    setQuantitePrime('');
  }
};



  const handleAddIndemnite = () => {
  if (selectedIndemnite && montantIndemnite && quantiteIndemnite) {
    setIndemnites(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        nonAssujettie: true,
        type: selectedIndemnite.label,
        idPrime: selectedIndemnite.idPrime,
        tauxFacture: selectedIndemnite.tauxFacture,
        montant: parseFloat(montantIndemnite),
        quantite: parseFloat(quantiteIndemnite),
      }
    ]);
    setSelectedIndemnite(null);
    setMontantIndemnite('');
    setQuantiteIndemnite('');
  }
};



const handleDeleteHeure = (id) => {
  setHeures(prev => prev.filter(p => p.id !== id));
};

const handleDeletePrime = (id) => {
  setPrimes(prev => prev.filter(p => p.id !== id));
};


const handleUpdateHeure = () => {
  const updatedRows = heures.map(row =>
    row.id === editingHeureId
      ? {
          ...row,
          type: selectedHeure.label,
          taux: selectedHeure.taux ?? row.taux,
          quantite: parseFloat(quantiteHeure)
        }
      : row
  );
  setHeures(updatedRows);
  setEditingHeureId(null);
  setSelectedHeure(null);
  setQuantiteHeure('');
};

const handleUpdatePrime = () => {
  const updatedRows = primes.map(row =>
    row.id === editingPrimeId
      ? {
          ...row,
          type: selectedPrime.label,
          idPrime: selectedPrime.idPrime || row.idPrime,
          tauxFacture: selectedPrime.tauxFacture ?? row.tauxFacture,
          montant: parseFloat(montantPrime),
          quantite: parseFloat(quantitePrime)
        }
      : row
  );
  setPrimes(updatedRows);
  setEditingPrimeId(null);
  setSelectedPrime(null);
  setMontantPrime('');
  setQuantitePrime('');
};


const startEditHeure = (row) => {
  setEditingHeureId(row.id);
  setSelectedHeure({ label: row.type });
  setQuantiteHeure(row.quantite); 
};


const startEditPrime = (row) => {
  setEditingPrimeId(row.id);
  setSelectedPrime({ label: row.type });
  setMontantPrime(row.montant ?? "");
  setQuantitePrime(row.quantite); 
};





  useEffect(() => {
    const id = new URLSearchParams(location.search).get("id");
    if (!id) return;
    let active = true;
    setReleveHeureId(id);
    setIsLoading(true);
    setLoadError("");
    setExcelFile(null);
    setEntryMode("manual");
    Promise.all([
      releveHeuresService.getMyReleveHeures(),
      axios.get("pld-contract/freelance"),
      axios.get("client/global-primes").catch(() => ({ data: [] })),
    ]).then(async ([rows, contractsResponse, globalRes]) => {
      if (!active) return;
      const raw = rows.find(row => String(row._id) === id);
      if (!raw) throw new Error("Relevé introuvable dans les dossiers de vos clients.");
      const row = releveHeuresService.transformToFrontendFormat(raw);
      if (row.attachmentName)
        releveHeuresService.getAttachment(id)
          .then(file => { if (active) { setExcelFile(file); setEntryMode("excel"); } })
          .catch(() => toast.error("Le fichier déposé sur ce relevé n’a pas pu être chargé."));
      const contracts = Array.isArray(contractsResponse.data) ? contractsResponse.data : [];
      const contract = contracts.find(item => String(item.NumeroContrat) === String(row.contractNumber) && String(item.NumeroAvenant ?? "") === String(row.amendmentNumber ?? "") && String(item.IdClient) === String(row.clientId));
      let clientPrimes = [];
      if (row.clientId) {
        try {
          const qualifications = await axios.get(`client/qualifications/${row.clientId}`);
          clientPrimes = qualifications.data?.TabPrimes || [];
        } catch { clientPrimes = []; }
      }
      if (!active) return;
      const catalog = mergePrimeCatalog(globalRes.data, clientPrimes, contract?.TabPrimes || []);
      const rated = applyPrimeRates(row.primes, catalog);
      setPrimeCatalog(catalog);
      setHeureCatalog(hourOptionsFromContract(contract));
      const start = parseDate(row.startDate);
      setTimeSheet({ ...row, contractStartDate: contract?.DateDebut || row.startDate, contractEndDate: contract?.DateFinMission || contract?.DateFin || row.endDate, weekNumber: start ? getISOWeek(start) : "—", year: start ? getISOWeekYear(start) : "—" });
      setHeures(row.heures);
      setPrimes(rated.filter(item => !item.nonAssujettie));
      setIndemnites(rated.filter(item => item.nonAssujettie));
      setClientComment(raw.CommentaireClient || raw.clientComment || "");
      setEmployeeComment(raw.CommentaireInterimaire || raw.employeeComment || "");
      setModificationRequested((raw.history || []).some(entry => entry.action === "Demande de modification du relevé par le freelance"));
      setIsLocked(["to_integrate", "integrated", "approved"].includes(row.status));
    }).catch(() => { if (active) setLoadError("Impossible d’afficher ce RH. Retournez à la liste et réessayez."); })
      .finally(() => { if (active) setIsLoading(false); });
    return () => { active = false; };
  }, [location.search]);

  const firstDay = parseDate(timeSheet.startDate);
  const weekStart = firstDay ? startOfISOWeek(firstDay) : null;
  const missionStart = parseDate(timeSheet.contractStartDate || timeSheet.startDate);
  const missionEnd = parseDate(timeSheet.contractEndDate || timeSheet.endDate);
  const weekDays = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"].map((name, index) => {
    const date = weekStart ? addDays(weekStart, index) : null;
    return { name, key: name.toLowerCase(), date: frenchDate(date), inContract: Boolean(date && missionStart && missionEnd && date >= missionStart && date <= missionEnd) };
  });

  // Fonction pour mettre à jour les heures
    
  // Fonction pour mettre à jour les heures de nuit
    
  // Fonction pour calculer le total des heures
  const calculateTotalHours = () => {
    let total = 0;
    
    // Somme des heures de jour
    Object.values(timeSheet.hours).forEach(hours => {
      if (hours) {
        total += parseFloat(hours);
      }
    });
    
    // Ajout des heures de nuit si nécessaire
    if (nightHoursOption === "additional") {
      Object.values(timeSheet.nightHours).forEach(hours => {
        if (hours) {
          total += parseFloat(hours);
        }
      });
    }
    
    return total;
  };
  
  // Calcul des heures supplémentaires (au-delà de l'horaire sélectionné)
const calculateOvertimeHours = () => {
  const total = calculateTotalHours();

  // Extraire le nombre d'heures depuis le string "31h", "33h", etc.
  const baseHours = parseInt(weekHoursOption?.replace("h", "")) || 35;

  return total > baseHours ? total - baseHours : 0;
};

  // Formatage des heures selon le mode sélectionné
  const formatHours = value => formatHourInput(value, hourFormat);

  // Fonction pour envoyer vers l'agence
  const sendToAgency = async () => {
    if (isLocked || isSaving) return;
    if (!validerAvantEnregistrement()) {
      return;
    }

    try {
      if (!releveHeureId) throw new Error("Relevé non enregistré");
      await releveHeuresService.markTransmitted(releveHeureId);
      setTimeSheet(prev => ({
        ...prev,
        status: "to_integrate"
      }));

      setIsLocked(true);
      toast.success("RH transmis à l’agence.");
    } catch (error) {
      console.error('Erreur lors de l\'envoi vers l\'agence:', error);
      toast.error('Erreur lors de l\'envoi vers l\'agence');
    }
  };

  // Fonction pour annuler le contrat
  
  // Fonction pour télécharger le relevé
  const downloadTimeSheet = () => {
    if (entryMode === "excel") {
      if (excelFile) saveAs(excelFile, excelFile.name);
      return;
    }
    try {
      const pdf = createTimesheetPdf(timeSheet, { heures, primes, indemnites, clientComment, employeeComment, hourFormat });
      const name = String(timeSheet.employeeName || "releve").replace(/[^\p{L}\p{N}_-]+/gu, "_");
      pdf.save(`releve_heures_${name}.pdf`);
    } catch { toast.error("Impossible de générer le PDF du relevé."); }
  };

  // Fonction pour obtenir le libellé du statut en français
  const getStatusLabel = (status) => {
    switch(status) {
      case "a_saisir":
        return "À saisir";
      case "a_valider":
        return "À valider";
      case "blocked":
        return "Bloqué";
      case "pending":
        return "En attente";
      case "approved":
        return "Approuvé";
      case "rejected":
        return "Rejeté";
      case "canceled":
        return "Annulé";
      case "to_integrate":
        return "À intégrer";
      case "integrated":
        return "Intégré";
      default:
        return "Inconnu";
    }
  };
  
  // Fonction pour obtenir la classe CSS selon le statut
  
  const handleHourChange = (dayKey, value) => {
    setTimeSheet(prev => ({
      ...prev,
      hours: {
        ...prev.hours,
        [dayKey]: value
      }
    }));
  };

  const handleNightHourChange = (dayKey, value) => {
    setTimeSheet(prev => ({
      ...prev,
      nightHours: {
        ...prev.nightHours,
        [dayKey]: value
      }
    }));
  };


  const validerAvantEnregistrement = () => {
  if (attachmentBusy) return false;
  if (entryMode === "excel") {
    if (!excelFile) { toast.error("Joignez le fichier Excel ou PDF des heures avant de continuer."); return false; }
    return true;
  }
  if (Object.values(invalidHourFields).some(Boolean)) {
    toast.error("Corrigez les heures indiquées en rouge avant d’enregistrer.");
    return false;
  }

  // Vérifie que "Fin de mission" est défini (true ou false)
  const finDeMissionRenseignee = typeof timeSheet.endOfMission === "boolean";


  const missingDays = missingAbsenceDays(timeSheet, weekDays);
  if (missingDays.length) {
    toast.error(`Renseignez un motif d’absence pour : ${missingDays.map(day => day.name.toLowerCase()).join(", ")}.`);
    document.getElementById(`rh-absence-${missingDays[0].key}`)?.focus();
    return false;
  }

   if (!finDeMissionRenseignee) {
    alert("Veuillez indiquer si c'est la fin de mission.");
    return false;
  }


  return true;
};


  return (
    <div className="rh-detail w-full">
      <div className="w-full">
        {/* Header Section */}
        <motion.div
          className="mb-6"
        >
          <div className="flex flex-wrap items-center justify-between gap-4">
            <PageHeading icon="hours" title="Relevé d'Heures" description={isLoading ? "Chargement du relevé…" : <>Semaine {timeSheet.weekNumber}/{timeSheet.year} · {frenchDate(timeSheet.startDate)} au {frenchDate(timeSheet.endDate)}</>} />

            <div className="flex flex-wrap items-center gap-3">
              <motion.button
                onClick={() => navigate("/relevesdheures")}
                className="p-3 bg-white rounded-xl shadow-sm border border-slate-200 hover:bg-slate-50 transition-colors duration-200 flex items-center space-x-2"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <ArrowLeft className="w-5 h-5 text-slate-600" />
                <span className="text-sm font-medium text-slate-700">Retour à la liste</span>
              </motion.button>
              {/* Statut Badge */}
              <motion.div
                className={`px-4 py-2 rounded-lg font-medium border ${
                  timeSheet.status === 'pending' ? 'bg-amber-50 text-amber-700 border-amber-200' :
                  timeSheet.status === 'integrated' ? 'bg-emerald-50 text-emerald-700 border-emerald-200' :
                  'bg-slate-50 text-slate-700 border-slate-200'
                }`}
                whileHover={{ scale: 1.02 }}
              >
                {getStatusLabel(timeSheet.status)}
              </motion.div>

            </div>
          </div>
        </motion.div>

        <nav aria-label="Étapes du relevé" className="rh-steps mb-5 flex flex-wrap gap-2">
          <a href="#rh-mission">1. Informations de la mission</a><a href="#rh-entry-mode">2. Heures ou fichier</a><a href="#rh-actions">3. Enregistrer et transmettre</a>
        </nav>
        {loadError ? <div role="alert" className="rounded-xl border border-red-200 bg-red-50 p-5 text-sm text-red-800">{loadError}</div> : isLoading ? (
          <motion.div
            role="status" aria-label="Chargement du relevé" className="flex justify-center items-center h-64"
          >
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          </motion.div>
        ) : (
          <div id="pdf-content">
            {/* Informations Employé */}
            <motion.div
              id="rh-mission" className="bg-white rounded-xl border border-slate-200 p-5 mb-5 scroll-mt-4"
            >
              <p className="mb-4 text-xs font-semibold uppercase tracking-wide text-blue-700">1. Informations de la mission</p>
              <div className="flex flex-wrap items-center gap-5">
                <div className="flex-1">
                  <h2 className="text-xl font-semibold text-slate-900">{timeSheet.employeeName}</h2>
                  <p className="text-sm text-slate-600">{timeSheet.employeePosition}</p>
                  <p className="mt-2 text-sm text-slate-700">Client : <strong>{timeSheet.clientName || "—"}</strong> · Contrat : <strong>{timeSheet.contractNumber || "—"}{timeSheet.amendmentNumber !== "" && timeSheet.amendmentNumber != null ? `.${timeSheet.amendmentNumber}` : ""}</strong></p>
                  <div className="flex flex-wrap items-center gap-2 mt-2">
                    <span className="text-sm text-slate-500">{timeSheet.employeeCompany}</span>
                    <span className="text-sm text-slate-400">•</span>
                    <span className="text-sm text-slate-500">ID: {timeSheet.employeeId}</span>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="text-right">
                    <p className="text-sm text-slate-500">Total semaine</p>
                    <p className="text-3xl font-bold text-slate-900">{entryMode === "excel" ? "Fichier joint" : `${calculateTotalHours().toFixed(1)}h`}</p>
                    {entryMode === "manual" && calculateOvertimeHours() > 0 && (
                      <p className="text-sm text-blue-600">+{calculateOvertimeHours().toFixed(1)}h sup.</p>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
            {entryMode === "manual" && <section aria-label="Réglages du relevé" className="mb-5 rounded-xl border border-slate-200 bg-white px-5 py-4">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-[1fr_1.5fr_1fr]">
                <div>
                  <label htmlFor="rh-end-mission" className="mb-1.5 block text-xs font-medium text-slate-600">Fin de mission</label>
                  {isPdfExporting ? <p className="text-sm">{timeSheet.endOfMission ? "Oui" : "Non"}</p> : <select id="rh-end-mission" value={timeSheet.endOfMission ? "oui" : "non"} disabled={isLocked && !modificationApproved} onChange={event => setTimeSheet(prev => ({ ...prev, endOfMission: event.target.value === "oui" }))} className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"><option value="non">Non</option><option value="oui">Oui</option></select>}
                </div>
                <div>
                  <label htmlFor="rh-project" className="mb-1.5 block text-xs font-medium text-slate-600">Chantier / Service</label>
                  {isPdfExporting ? <p className="text-sm">{timeSheet.projectNumber || "—"}</p> : <input id="rh-project" type="text" value={timeSheet.projectNumber || ""} disabled={isLocked && !modificationApproved} onChange={event => setTimeSheet(prev => ({ ...prev, projectNumber: event.target.value }))} placeholder="N° chantier ou service" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" />}
                </div>
                <div>
                  <label htmlFor="rh-hour-format" className="mb-1.5 block text-xs font-medium text-slate-600">Format des heures</label>
                  {isPdfExporting ? <p className="text-sm">{hourFormat === "minutes" ? "Minutes" : "Centièmes"}</p> : <select id="rh-hour-format" value={hourFormat} onChange={event => setHourFormat(event.target.value)} className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"><option value="minutes">Minutes (7:30)</option><option value="centiemes">Centièmes (7,50)</option></select>}
                </div>
              </div>
            </section>}
            {!isPdfExporting && <section id="rh-entry-mode" className="mb-5 rounded-xl border border-slate-200 bg-white p-5">
              <h3 className="mb-3 text-base font-semibold text-slate-900">Comment souhaitez-vous renseigner les heures ?</h3>
              <div className="flex flex-wrap gap-2">{[["manual", "Saisir les heures"], ["excel", "Joindre un fichier Excel ou PDF"]].map(([mode, label]) => <button key={mode} type="button" aria-pressed={entryMode === mode} disabled={isLocked || attachmentBusy} onClick={() => setEntryMode(mode)} className={`rounded-lg border px-4 py-2 text-sm font-medium ${entryMode === mode ? "border-blue-600 bg-blue-50 text-blue-800" : "border-slate-200 text-slate-600"}`}>{label}</button>)}</div>
              {entryMode === "excel" && <div className="mt-4 space-y-3">
                <p className="text-sm text-slate-600">Le fichier remis par le client est enregistré sur ce relevé. Il reste téléchargeable ici et dans l’admin. Excel (.xlsx, .xls) ou PDF, 10 Mo maximum.</p>
                <input type="file" accept=".xlsx,.xls,.pdf" aria-label="Joindre les heures au format Excel ou PDF" disabled={isLocked || attachmentBusy} onChange={attachExcel} className="block w-full text-sm" />
                {attachmentBusy && <p role="status" className="text-sm text-slate-500">Enregistrement du fichier…</p>}
                {excelFile && <div className="flex flex-wrap items-center gap-3 rounded-lg bg-slate-50 p-3"><span className="break-all text-sm font-medium">{excelFile.name}</span><button type="button" onClick={() => saveAs(excelFile, excelFile.name)} className="text-sm text-blue-700">Télécharger</button><button type="button" disabled={isLocked || attachmentBusy} onClick={removeExcel} className="text-sm text-red-600">Retirer</button></div>}
                <p className="text-xs text-slate-500">Le fichier est enregistré sur le relevé et visible par l’agence.</p>
              </div>}
            </section>}
            {entryMode === "excel" && isPdfExporting && <p>Heures fournies dans le fichier joint : {excelFile?.name || "—"}</p>}
            {entryMode === "manual" && <>
            {/* Tableau des Heures */}
            <motion.div
              id="rh-hours" className="bg-white rounded-xl border border-slate-200 overflow-hidden mb-5 scroll-mt-4"
            >
              <div className="px-6 py-4 border-b border-slate-200">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-slate-900">2. Heures travaillées</h3>
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                      <div className="flex items-center space-x-1">
                        <div className="w-3 h-3 rounded-full bg-amber-100 border border-amber-300"></div>
                        <span className="text-xs text-slate-500">Heures de nuit</span>
                      </div>
                      <span className="text-slate-300">•</span>
                      <span className="text-xs text-slate-500">
                        {nightHoursOption === "included" ? "Incluses" : "Additionnelles"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-5">
                <p className="mb-4 text-sm text-slate-500">Renseignez les heures de chaque jour. Pour les jours du contrat sans heures saisies, choisissez un motif d’absence. Les jours hors contrat sont grisés. Les heures de nuit s’ajoutent aux heures de jour. {hourFormat === "minutes" ? "Exemple : 7:30 pour 7 heures et 30 minutes." : "Exemple : 7,50 pour 7 heures et 30 minutes."}</p>
                <div className="overflow-x-auto">
                  <div className="grid grid-cols-8 gap-4 min-w-max">
                    {/* En-tête */}
                    <div className="flex items-center justify-center">
                      <span className="text-sm font-medium text-slate-600">Type</span>
                    </div>
                    {weekDays.map((day) => (
                      <div key={`head-${day.key}`} className={`text-center rounded-lg ${day.inContract ? "" : "bg-slate-100 opacity-50"}`}>
                        <p className="font-medium text-slate-800">{day.name}</p>
                        <p className="text-xs text-slate-500">{day.date}</p>
                      </div>
                    ))}

                    {/* Heures de jour */}
                    <div className="flex items-center justify-center">
                      <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center">
                          <Sun className="w-4 h-4 text-amber-600" />
                        </div>
                        <span className="text-sm font-medium text-slate-700">Jour</span>
                      </div>
                    </div>
                    {weekDays.map((day, index) => (
                      <div key={`day-${day.key}`} className={`flex justify-center rounded-lg ${day.inContract ? "" : "bg-slate-100 opacity-50"}`}>
                        {isPdfExporting ? (
                          <div className="w-20 h-12 text-center text-sm flex items-center justify-center text-slate-800 bg-slate-50 rounded-lg border">
                            {formatHours(timeSheet.hours[day.key]) || "-"}
                          </div>
                        ) : (
                          <HourInput id={`rh-jour-${day.key}`} label={`Heures de jour du ${day.name}`} value={timeSheet.hours[day.key]} format={hourFormat} disabled={!day.inContract || (isLocked && !modificationApproved)} onChange={value => handleHourChange(day.key, value)} onValidityChange={valid => hourValidity(`jour-${day.key}`, valid)} />
                        )}
                      </div>
                    ))}

                    {/* Heures de nuit */}
                    <div className="flex items-center justify-center">
                      <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                          <Moon className="w-4 h-4 text-blue-600" />
                        </div>
                        <span className="text-sm font-medium text-slate-700">Nuit</span>
                      </div>
                    </div>
                    {weekDays.map((day, index) => (
                      <div key={`night-${day.key}`} className={`flex justify-center rounded-lg ${day.inContract ? "" : "bg-slate-100 opacity-50"}`}>
                        {isPdfExporting ? (
                          <div className="w-20 h-12 text-center text-sm flex items-center justify-center text-slate-800 bg-slate-50 rounded-lg border">
                            {formatHours(timeSheet.nightHours[day.key]) || "-"}
                          </div>
                        ) : (
                          <HourInput id={`rh-nuit-${day.key}`} label={`Heures de nuit du ${day.name}`} value={timeSheet.nightHours[day.key]} format={hourFormat} disabled={!day.inContract || (isLocked && !modificationApproved)} onChange={value => handleNightHourChange(day.key, value)} onValidityChange={valid => hourValidity(`nuit-${day.key}`, valid)} />
                        )}
                      </div>
                    ))}
                    <div className="flex items-center justify-center"><span className="text-sm font-medium text-slate-700">Motif d’absence</span></div>
                    {weekDays.map(day => <div key={`absence-${day.key}`} className="min-w-0">
                      {!day.inContract ? <p className="rounded-lg bg-slate-100 py-3 text-center text-xs text-slate-400">Hors contrat</p> : hasDayHours(timeSheet, day.key) ? <p className="py-3 text-center text-xs text-slate-400">—</p> : isPdfExporting ? <p className="text-center text-xs">{absenceReasons.find(([code]) => code === timeSheet.absences?.[day.key])?.[1] || timeSheet.absences?.[day.key] || "Non renseigné"}</p> : <>
                        <select id={`rh-absence-${day.key}`} aria-label={`Motif d’absence du ${day.name}`} value={timeSheet.absences?.[day.key] || ""} onChange={event => setTimeSheet(prev => ({ ...prev, absences: { ...prev.absences, [day.key]: event.target.value } }))} disabled={isLocked && !modificationApproved} required className={`h-12 w-full rounded-lg border px-2 text-xs ${timeSheet.absences?.[day.key] ? "border-slate-200" : "border-amber-300 bg-amber-50"}`}>
                          <option value="">Choisir un motif</option>
                          {timeSheet.absences?.[day.key] && !absenceReasons.some(([code]) => code === timeSheet.absences[day.key]) && <option value={timeSheet.absences[day.key]}>{timeSheet.absences[day.key]}</option>}
                          {absenceReasons.map(([code, label]) => <option key={code} value={code}>{label}</option>)}
                        </select>
                      </>}
                    </div>)}
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Résumé de la semaine */}
            <motion.div
              className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl shadow-sm border border-blue-200 p-6 mb-8"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-blue-600 rounded-xl">
                    <Clock className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-900">Total de la semaine</h3>
                    <p className="text-blue-700">Récapitulatif des heures travaillées</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-4xl font-bold text-blue-900">
                    {calculateTotalHours().toFixed(1)}h
                  </div>
                  {calculateOvertimeHours() > 0 && (
                    <div className="text-sm text-blue-700 font-medium">
                      +{calculateOvertimeHours().toFixed(1)}h supplémentaires
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
            {/* Section heures diverses */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-3 bg-green-100 rounded-xl">
                  <DollarSign className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900">Heures diverses</h3>
                  <p className="text-sm text-slate-600">Ces heures seront facturées au même taux que les heures normales</p>
                </div>
              </div>

              {!isPdfExporting && (
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                  {/* Type d'heure */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Type d'heure</label>
                    <Select
                      value={selectedHeure}
                      disabled={isLocked && !modificationApproved}
                      onChange={(value) => { setSelectedHeure(value); }}
                      isDisabled={isLocked && !modificationApproved} options={catalogs.hours} aria-label="Type d’heure"
                      placeholder="Sélectionner un type d’heure"
                      className="text-sm"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: '#e2e8f0',
                          borderRadius: '0.75rem',
                          minHeight: '48px',
                          '&:hover': { borderColor: '#3b82f6' },
                          '&:focus': { borderColor: '#3b82f6', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.1)' }
                        })
                      }}
                    />
                  </div>

                  {/* Quantité */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Quantité</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      step="0.1"
                      value={quantiteHeure}
                      onChange={(e) => setQuantiteHeure(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.0"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Bouton Ajouter/Modifier */}
                  <div className="flex items-end">
                    {editingHeureId ? (
                      <motion.button
                        disabled={isLocked && !modificationApproved} onClick={handleUpdateHeure}
                        className="w-full h-12 px-4 bg-green-600 text-white rounded-xl hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Edit3 className="w-4 h-4" />
                        <span>Enregistrer</span>
                      </motion.button>
                    ) : (
                      <motion.button
                        disabled={isLocked && !modificationApproved} onClick={handleAddHeure}
                        className="w-full h-12 px-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Plus className="w-4 h-4" />
                        <span>Ajouter</span>
                      </motion.button>
                    )}
                  </div>
                </div>
              )}

              {/* Liste des heures ajoutées */}
              <div className="space-y-3 mt-6">
                <AnimatePresence>
                  {visibleHeures.map((row, index) => (
                    <motion.div
                      key={row.id}
                      className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200"
                      whileHover={{ y: -2 }}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                        <div>
                          <span className="font-medium text-slate-800">{row.type}</span>
                          <span className="ml-2 text-slate-600">({row.quantite}h)</span>
                        </div>
                      </div>
                      {!isPdfExporting && (
                        <div className="flex space-x-2">
                          <motion.button
                            disabled={isLocked && !modificationApproved} onClick={() => startEditHeure(row)}
                            className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Pencil className="h-4 w-4" />
                          </motion.button>
                          <motion.button
                            disabled={isLocked && !modificationApproved} onClick={() => handleDeleteHeure(row.id)}
                            className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Trash2 className="h-4 w-4" />
                          </motion.button>
                        </div>
                      )}
                    </motion.div>
                  ))}
                </AnimatePresence>
                {visibleHeures.length === 0 && (
                  <div className="text-center py-8">
                    <div className="text-slate-400 mb-2">
                      <FileText className="w-12 h-12 mx-auto" />
                    </div>
                    <p className="text-slate-500">Aucune heure diverse ajoutée</p>
                  </div>
                )}
              </div>
            </motion.div>
            {/* Section primes */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-3 bg-purple-100 rounded-xl">
                  <Gift className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900">Primes</h3>
                  <p className="text-sm text-slate-600">Ces primes sont assujetties aux charges sociales</p>
                </div>
              </div>

              {!isPdfExporting && (
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                  {/* Type de prime */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Type de prime</label>
                    <Select
                      value={selectedPrime}
                      disabled={isLocked && !modificationApproved}
                      onChange={(value) => { setSelectedPrime(value); setMontantPrime(value?.montant != null ? String(value.montant) : ""); }}
                      isDisabled={isLocked && !modificationApproved} options={catalogs.primes} aria-label="Type de prime"
                      placeholder="Sélectionner une prime"
                      className="text-sm"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: '#e2e8f0',
                          borderRadius: '0.75rem',
                          minHeight: '48px',
                          '&:hover': { borderColor: '#3b82f6' },
                          '&:focus': { borderColor: '#3b82f6', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.1)' }
                        })
                      }}
                    />
                  </div>

                  {/* Quantité */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Quantité</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      value={quantitePrime}
                      onChange={(e) => setQuantitePrime(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.00"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Montant Prime */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Taux (€)</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      step="0.01"
                      value={montantPrime}
                      onChange={(e) => setMontantPrime(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.00"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Bouton Ajouter/Modifier */}
                  <div className="flex items-end">
                    {editingPrimeId ? (
                      <motion.button
                        disabled={isLocked && !modificationApproved} onClick={handleUpdatePrime}
                        className="w-full h-12 px-4 bg-green-600 text-white rounded-xl hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Edit3 className="w-4 h-4" />
                        <span>Enregistrer</span>
                      </motion.button>
                    ) : (
                      <motion.button
                        disabled={isLocked && !modificationApproved} onClick={handleAddPrime}
                        className="w-full h-12 px-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Plus className="w-4 h-4" />
                        <span>Ajouter</span>
                      </motion.button>
                    )}
                  </div>
                </div>
              )}

              {/* Liste des primes ajoutées */}
              <div className="space-y-3 mt-6">
                <AnimatePresence>
                  {primes.map((row, index) => (
                    <motion.div
                      key={row.id}
                      className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200"
                      whileHover={{ y: -2 }}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                        <div>
                          <span className="font-medium text-slate-800">{row.type}</span>
                          <span className="ml-2 text-slate-600">{primeSummary(row)}</span>
                        </div>
                      </div>
                      {!isPdfExporting && (
                        <div className="flex space-x-2">
                          <motion.button
                            disabled={isLocked && !modificationApproved} onClick={() => startEditPrime(row)}
                            className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Pencil className="h-4 w-4" />
                          </motion.button>
                          <motion.button
                            disabled={isLocked && !modificationApproved} onClick={() => handleDeletePrime(row.id)}
                            className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Trash2 className="h-4 w-4" />
                          </motion.button>
                        </div>
                      )}
                    </motion.div>
                  ))}
                </AnimatePresence>
                {primes.length === 0 && (
                  <div className="text-center py-8">
                    <div className="text-slate-400 mb-2">
                      <Gift className="w-12 h-12 mx-auto" />
                    </div>
                    <p className="text-slate-500">Aucune prime ajoutée</p>
                  </div>
                )}
              </div>
            </motion.div>

            {/* Section primes */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-3 bg-cyan-100 rounded-xl">
                  <Gift className="w-6 h-6 text-cyan-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900">Indemnités non assujetties</h3>
                  <p className="text-sm text-slate-600">Renseignez les indemnités non assujetties du relevé.</p>
                </div>
              </div>

              {!isPdfExporting && (
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                  {/* Type d’indemnité */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Type d’indemnité</label>
                    <Select
                      value={selectedIndemnite}
                      disabled={isLocked && !modificationApproved}
                      onChange={(value) => { setSelectedIndemnite(value); const rate = value?.montantNonAssujetti ?? value?.montant; setMontantIndemnite(rate != null ? String(rate) : ""); }}
                      isDisabled={isLocked && !modificationApproved} options={indemniteCatalog} aria-label="Type d’indemnité"
                      placeholder="Sélectionner une indemnité"
                      className="text-sm"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: '#e2e8f0',
                          borderRadius: '0.75rem',
                          minHeight: '48px',
                          '&:hover': { borderColor: '#3b82f6' },
                          '&:focus': { borderColor: '#3b82f6', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.1)' }
                        })
                      }}
                    />
                  </div>

                  {/* Quantité */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Quantité</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      value={quantiteIndemnite}
                      onChange={(e) => setQuantiteIndemnite(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.00"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Montant Prime */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Taux (€)</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      step="0.01"
                      value={montantIndemnite}
                      onChange={(e) => setMontantIndemnite(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.00"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Bouton Ajouter/Modifier */}
                  <div className="flex items-end">
                    {editingIndemniteId ? (
                      <motion.button
                        disabled={(isLocked && !modificationApproved) || !selectedIndemnite || Number(quantiteIndemnite) <= 0 || montantIndemnite === "" || Number(montantIndemnite) < 0} onClick={handleUpdateIndemnite}
                        className="w-full h-12 px-4 bg-green-600 text-white rounded-xl hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Edit3 className="w-4 h-4" />
                        <span>Enregistrer</span>
                      </motion.button>
                    ) : (
                      <motion.button
                        disabled={(isLocked && !modificationApproved) || !selectedIndemnite || Number(quantiteIndemnite) <= 0 || montantIndemnite === "" || Number(montantIndemnite) < 0} onClick={handleAddIndemnite}
                        className="w-full h-12 px-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Plus className="w-4 h-4" />
                        <span>Ajouter</span>
                      </motion.button>
                    )}
                  </div>
                </div>
              )}

              {/* Liste des primes ajoutées */}
              <div className="space-y-3 mt-6">
                <AnimatePresence>
                  {indemnites.map((row, index) => (
                    <motion.div
                      key={row.id}
                      className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200"
                      whileHover={{ y: -2 }}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="w-2 h-2 rounded-full bg-cyan-500"></div>
                        <div>
                          <span className="font-medium text-slate-800">{row.type}</span>
                          <span className="ml-2 text-slate-600">{primeSummary(row)}</span>
                        </div>
                      </div>
                      {!isPdfExporting && (
                        <div className="flex space-x-2">
                          <motion.button
                            disabled={isLocked && !modificationApproved} onClick={() => startEditIndemnite(row)}
                            className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Pencil className="h-4 w-4" />
                          </motion.button>
                          <motion.button
                            disabled={isLocked && !modificationApproved} onClick={() => handleDeleteIndemnite(row.id)}
                            className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Trash2 className="h-4 w-4" />
                          </motion.button>
                        </div>
                      )}
                    </motion.div>
                  ))}
                </AnimatePresence>
                {indemnites.length === 0 && (
                  <div className="text-center py-8">
                    <div className="text-slate-400 mb-2">
                      <Gift className="w-12 h-12 mx-auto" />
                    </div>
                    <p className="text-slate-500">Aucune indemnité ajoutée</p>
                  </div>
                )}
              </div>
            </motion.div>

            {/* Section commentaires */}
            <motion.div
              className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8"
            >
              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <MessageSquare className="w-5 h-5 text-blue-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900">Commentaire du client</h3>
                </div>
                {isPdfExporting ? (
                  <p className="text-sm text-slate-800 whitespace-pre-wrap">{clientComment}</p>
                ) : (
                  <motion.textarea
                    className="w-full h-32 px-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-200"
                    value={clientComment}
                    disabled={isLocked && !modificationApproved}
                    onChange={(e) => setClientComment(e.target.value)}
                    placeholder="Saisissez un commentaire..."
                    whileFocus={{ scale: 1.02 }}
                  />
                )}
              </motion.div>

              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-green-100 rounded-lg">
                    <User className="w-5 h-5 text-green-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900">Commentaire de l'intérimaire</h3>
                </div>
                {isPdfExporting ? (
                  <p className="text-sm text-slate-800 whitespace-pre-wrap">...</p>
                ) : (
                  <motion.textarea
                    className="w-full h-32 px-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-200"
                    placeholder="Pour information, voici le commentaire de l'intérimaire"
                    disabled={isLocked && !modificationApproved}
                    whileFocus={{ scale: 1.02 }}
                  />
                )}
              </motion.div>
            </motion.div>

            </>}
            {/* Boutons d'action */}
            {!isPdfExporting && (
              <motion.div
                id="rh-actions" className="rh-actions sticky bottom-0 z-10 flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm scroll-mt-4"
              >
                <div className="w-full"><p className="mb-2 text-xs text-slate-500">{isLocked ? "Ce RH est verrouillé après transmission." : "Vous pouvez enregistrer et modifier ce RH autant de fois que nécessaire avant sa transmission."}</p><h3 className="text-base font-semibold text-slate-900">3. Enregistrer et transmettre</h3><p className="mt-1 text-xs text-slate-500">Vérifiez les heures avant d’enregistrer le relevé.</p></div>
                <motion.button
                  onClick={handleSave}
                  disabled={isLocked || isSaving || attachmentBusy}
                  className={`px-6 py-3 rounded-xl font-medium transition-all duration-200 flex items-center space-x-2 ${
                    isLocked || isSaving
                      ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                      : "bg-blue-700 hover:bg-blue-800 text-white"
                  }`}
                  whileHover={!isLocked && !isSaving ? { scale: 1.02, y: -2 } : {}}
                  whileTap={!isLocked && !isSaving ? { scale: 0.98 } : {}}
                >
                  <Save className="w-5 h-5" />
                  <span>{isSaving ? "Enregistrement..." : "Enregistrer"}</span>
                </motion.button>

                <motion.button
                  onClick={sendToAgency}
                  disabled={isLocked || isSaving || attachmentBusy}
                  className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl flex items-center space-x-2"
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Send className="w-5 h-5" />
                  <span>{isLocked ? "Transmis à l’agence" : "Envoyer vers l’agence"}</span>
                </motion.button>


                <motion.button
                  onClick={downloadTimeSheet}
                  className="px-6 py-3 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl flex items-center space-x-2"
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Download className="w-5 h-5" />
                  <span>{entryMode === "excel" ? "Télécharger le document" : "Télécharger PDF"}</span>
                </motion.button>

                <motion.button
                  onClick={handleModificationRequest}
                  disabled={!isLocked || modificationRequested}
                  className={`px-6 py-3 rounded-xl font-medium transition-all duration-200 flex items-center space-x-2 ${
                    (!isLocked || modificationRequested)
                      ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                      : "bg-slate-600 hover:bg-slate-700 text-white shadow-lg hover:shadow-xl"
                  }`}
                  whileHover={(!isLocked && !modificationRequested) ? { scale: 1.02, y: -2 } : {}}
                  whileTap={(!isLocked && !modificationRequested) ? { scale: 0.98 } : {}}
                >
                  <AlertCircle className="w-5 h-5" />
                  <span>{modificationRequested ? "Demande envoyée" : "Demande de modification"}</span>
                </motion.button>
              </motion.div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RelevesHeures;